// Create page title from the route path
// iIf route has [pid] at the end it will be removed.
// E.g. /teams/[pid] page will have title "Scribe | Teams".
// This is just to avoid new created page to be without title tag.
// This code also removes the '/shared/' or '/page/' prefixes and
// remove the UUID suffix. For example, the title for
// /page/Just_a_page__Z5guTAHsRtGq0FB3471Fkg will be shown as "Scribe | Just a page".
// you can/should always override head tags by adding specific ones at created page itself
import { NextRouter } from 'next/router';

import { uuidV4Regex } from './uuidHelpers';

const urlPartsRegex = new RegExp(/[-/]/, 'g');
const namePartsRegex = new RegExp('_+', 'g');

const guessNameFromPath = (path: string): string => {
  let parts = path.split('__');

  if (parts.length > 1) {
    parts = parts.slice(0, -1);
  }
  path = parts.join('__');
  path = path.replace(namePartsRegex, ' ');
  return path;
};

// Remove "/shared/" / "/page/" prefix or any full uuids
const beautifyPath = (path: string): string => {
  let beautifiedPath = path;
  const pathPrefixesToBeBeautified: string[] = ['/shared/', '/page/'];

  for (let ind = 0; ind < pathPrefixesToBeBeautified.length; ind++) {
    const prefix = pathPrefixesToBeBeautified[ind];

    if (path.indexOf(prefix) === 0) {
      beautifiedPath = path.replace(prefix, '');
      break;
    }
  }
  // If it contains a UUID, remove it
  if (uuidV4Regex.test(beautifiedPath)) {
    beautifiedPath = beautifiedPath.replace(uuidV4Regex, '');
  }

  return beautifiedPath;
};

export const pageTitle = (routerObject: NextRouter): string => {
  // Get path without query params
  const routerAsPathWithoutQueryParams = routerObject.asPath.split('?')?.[0]; // remove query params
  // Determine if the path begins with /shared/ or /page/ and remove the prefix
  const beautifiedPath = beautifyPath(routerAsPathWithoutQueryParams);
  const needsBeautifying = beautifiedPath.length !== routerAsPathWithoutQueryParams.length;
  // Transform into a more human-readable form and capitalize words
  let pathNameParts: string[] = beautifiedPath.split(urlPartsRegex);

  pathNameParts = pathNameParts.map((s) => s.charAt(0).toUpperCase() + s.slice(1));
  pathNameParts = pathNameParts.filter((part) => !!part && part.trim().length > 0);
  // Remove hash
  let pathName = pathNameParts.join(' ').split('#')[0];
  // If it was beautified, try to guess the name from the URL

  if (needsBeautifying && pathName) {
    pathName = guessNameFromPath(pathName);
    return pathName;
  }

  // Do the rest as we have been so far
  if (pathName) {
    return `Scribe | ${pathName}`;
  }
  return 'Scribe';
};
